import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const repairInvoicePostingSideEffects = createAsyncThunk(
  "InvoiceRepair/postingSideEffects",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        ADMIN_API_URL.INVOICE_REPAIR.POSTING_SIDE_EFFECTS,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data ?? error);
    }
  }
);

const invoiceRepairSlice = createSlice({
  name: "invoiceRepair",
  initialState: {
    lastResult: null,
  },
  reducers: {
    clearLastResult(state) {
      state.lastResult = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(repairInvoicePostingSideEffects.fulfilled, (state, action) => {
      state.lastResult = action.payload;
    });
  },
});

export const { clearLastResult } = invoiceRepairSlice.actions;
export default invoiceRepairSlice.reducer;
